module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/suits-1fb926c162789fcfa43270556398b845.png";